import React from 'react';
import {ErrorModal} from '../../../system/ErrorModal/ErrorModal';

export const GetPurchaseCouponErrorModal = ({
  isOpen,
  onClose,
  checkoutSessionId,
}: {
  isOpen: boolean;
  onClose: () => void;
  checkoutSessionId: string;
}) => {
  return (
    <ErrorModal
      isOpen={isOpen}
      onClose={onClose}
      message={
        <>
          We've received your payment but something went wrong during the coupon
          generation
        </>
      }
      additionalMascotUrl="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Fgift-mascot-800.png"
      mascotUrl="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Ferror-mascot-1.png"
      additionalMeassage={
        <>
          We will contact you shortly or you can{' '}
          <a target="_blank" href="https://pulsoid.net/contact">
            contact us
          </a>{' '}
          with the following details:
          <div
            style={{
              fontSize: 17,
              lineHeight: '20px',
              textAlign: 'center',
              padding: 15,
            }}
          >
            Checkout session id:
            <br />
            {checkoutSessionId}
          </div>
        </>
      }
    />
  );
};
